const contact_masters = (state) => state.contact_masters;
const contact_master = (state) => state.contact_master;

export default {
  contact_masters,
  contact_master,
};
